import readIsManaVersionFlag from "@/shared/manaVersionHelper";

export const DEFAULT_PROJECT = {
  id: "",
  name: readIsManaVersionFlag() ? 'MANA products' : 'Global products',
  checkedProducts: {}
};

export const DEFAULT_CUSTOM_SELECTION_NAME = 'New project';

export const COMMAND_NAME = {
  DELETE: 'delete',
  EDIT: 'edit'
};
